import { Pedclid } from './../../classes/pedido';

export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_CART = 'UPDATE_CART';
export const EMPTY_CART = 'EMPTY_CART';

export const emptyCart = () => ({ type: EMPTY_CART });
export const removeFromCart = (CODART: string) => ({ type: REMOVE_FROM_CART, CODART });
export const updateCart = (pedclid: Pedclid) => ({ type: UPDATE_CART, pedclid });
